import { useQuery } from '@tanstack/react-query';
import API from '../../../context/API';
import type { Store } from '../store/userStoresSlice';

export const STORES_QUERY_KEY = ['stores'] as const;

export const useStores = () => {
  return useQuery<Store[]>({
    queryKey: STORES_QUERY_KEY,
    queryFn: async () => {
      // GET /stores is role-aware server-side: admins get every store across
      // every merchant (no merchant filter applied), merchant/merchant_manager/
      // merchant_staff get only their own merchant's stores via the JWT.
      // There's no merchantId to pass from the client for either case.
      const token = localStorage.getItem('access_token');
      const res = await API.get('/stores', {
        headers: { Authorization: `Bearer ${token}` },
      });
      return res.data.data || [];
    },
    // The store list rarely changes, so it's never considered stale on its
    // own (no refetch from tab navigation, remounts, or window focus) —
    // useStoreMutations explicitly invalidates this key on create/update/
    // delete, and that invalidation still refetches on the next mount or
    // active observer, so a newly created store shows up without a page
    // refresh.
    staleTime: Infinity,
  });
};
